/** The words of the airports admin page (SA-1054 §5.3). Every sentence the page prints is here. */
import { ApiError } from '@/services/apiClient'
import type { Airport } from '@/types/airports'

export const PAGE_TITLE = 'Airports'
export const PAGE_SENTENCE =
  "The name and city your team uses for a station. They are used in place of the source's words wherever the product names it."
export const SEARCH_LABEL = 'Search stations'
export const SEARCH_PLACEHOLDER = 'Search by code, name or city'
export const SEARCH_RESULTS = 'Search results'
export const SEARCHING = 'Searching…'
export const SEARCH_FAILED = 'The search failed. Try again.'
export const HOUSE_HEADING = 'Stations with your names'
export const HOUSE_EMPTY = 'No station carries your names yet.'
export const HOUSE_UNAVAILABLE = 'The stations with your names could not be loaded.'
export const RETIRED = 'Retired'
export const NO_SOURCE_CITY = 'no city in the source'
export const EMPTY_FIELD_HINT = "Leave a field empty to use the source's words."
export const SOURCE_NAME = 'Source name'
export const SOURCE_CITY = 'Source city'
export const HOUSE_NAME = 'House name'
export const HOUSE_CITY = 'House city'

/** The code the product shows for a station: IATA, else ICAO, else the ident. */
export function codeOf(a: Airport): string {
  return a.iata ?? a.icao ?? a.ident
}

/** The source city, or the words for its absence (an empty string counts as absent). */
export function sourceCity(a: Airport): string {
  return a.city || NO_SOURCE_CITY
}

export function sourceLine(a: Airport): string {
  return `Source: ${a.name} · ${sourceCity(a)}`
}

export function houseHeading(count: number): string {
  return `${HOUSE_HEADING} (${count})`
}

export function noMatch(text: string): string {
  return `No station matches “${text}”.`
}

export function dialogTitle(a: Airport): string {
  return `Your names for ${codeOf(a)}`
}

/** A refused save in words; never a bare status or the server's detail. */
export function saveErrorText(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 404) return 'This station is no longer in the reference.'
    if (error.status === 403) return "Only an admin can change a station's names."
    if (error.status === 422) return 'A name or a city can be at most 255 characters.'
  }
  return 'The names were not saved. Try again.'
}
